const features = [
  {
    icon: 'ri-leaf-line',
    title: 'Écologique & Durable',
    description: 'Réduisez votre empreinte carbone de 70% avec les PAC ELCO. Fluides frigorigènes R32 à faible GWP, énergies renouvelables.',
    stat: '-70%',
    statLabel: 'CO₂',
  },
  {
    icon: 'ri-money-euro-circle-line',
    title: 'Économies Garanties',
    description: 'Divisez vos factures de chauffage par 3 à 4. COP exceptionnel jusqu\'à 5.2. Amortissement rapide grâce aux subventions.',
    stat: '÷3',
    statLabel: 'Facture',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Qualité Suisse ELCO',
    description: 'Leader suisse depuis 1928. Composants premium, fabrication suisse, garanties constructeur étendues jusqu\'à 7 ans.',
    stat: '1928',
    statLabel: 'Fondé en',
  },
  {
    icon: 'ri-tools-line',
    title: 'Installation Certifiée',
    description: 'Techniciens certifiés ELCO, dimensionnement précis, mise en service complète et formation personnalisée incluse.',
    stat: '100%',
    statLabel: 'Certifié',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'SAV 24/7',
    description: 'Maintenance préventive annuelle, dépannage rapide 24/7, pièces d\'origine ELCO. Contrats d\'entretien sur mesure.',
    stat: '24/7',
    statLabel: 'Disponible',
  },
  {
    icon: 'ri-home-smile-line',
    title: 'Confort Optimal',
    description: 'Chauffage homogène et silencieux, eau chaude sanitaire, compatible plancher chauffant et radiateurs. Régulation intelligente.',
    stat: 'A+++',
    statLabel: 'Efficacité',
  },
];

export default function Features() {
  return (
    <section id="avantages" className="py-20 bg-gray-950">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">

        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/25 rounded-full px-4 py-1.5 mb-5">
              <i className="ri-temp-hot-line text-amber-400 text-sm"></i>
              <span className="text-xs font-bold tracking-widest uppercase text-amber-400">Avantages ELCO</span>
            </div>
            <h2 className="text-3xl font-bold text-white sm:text-4xl">
              Pourquoi choisir une<br />
              <span className="text-amber-400">pompe à chaleur ELCO ?</span>
            </h2>
          </div>
          <p className="text-gray-400 text-sm max-w-sm leading-relaxed">
            Performance, fiabilité et économies pour votre chauffage à Genève et en Suisse romande.
          </p>
        </div>

        {/* Cards 3x2 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f, i) => (
            <div key={i} className="bg-gray-900 rounded-2xl p-6 border border-white/5 hover:border-amber-500/30 transition-all group">
              <div className="flex items-start justify-between mb-5">
                <div className="w-11 h-11 flex items-center justify-center bg-amber-500/15 border border-amber-500/30 rounded-xl group-hover:bg-amber-500 group-hover:border-amber-500 transition-all">
                  <i className={`${f.icon} text-amber-400 group-hover:text-white transition-colors`}></i>
                </div>
                <div className="text-right">
                  <div className="text-xl font-bold text-amber-400">{f.stat}</div>
                  <div className="text-xs text-gray-500">{f.statLabel}</div>
                </div>
              </div>
              <h3 className="text-sm font-bold text-white mb-2">{f.title}</h3>
              <p className="text-gray-400 text-xs leading-relaxed">{f.description}</p>
            </div>
          ))}
        </div>

        {/* Banner subventions */}
        <div className="mt-10 flex flex-col sm:flex-row items-center gap-6 bg-amber-500/8 border border-amber-500/20 rounded-2xl px-8 py-6">
          <div className="w-12 h-12 flex items-center justify-center bg-amber-500 rounded-xl shrink-0">
            <i className="ri-money-euro-circle-line text-white text-xl"></i>
          </div>
          <div className="flex-1 text-center sm:text-left">
            <h3 className="text-base font-bold text-white mb-1">Subventions cantonales jusqu'à CHF 10'000.-</h3>
            <p className="text-gray-400 text-sm">Profitez des aides cantonales genevoises et du programme fédéral. Nous vous accompagnons dans toutes vos démarches administratives.</p>
          </div>
          <a href="#contact" className="shrink-0 inline-flex items-center gap-2 rounded-lg bg-amber-500 px-5 py-2.5 text-sm font-semibold text-white hover:bg-amber-600 transition-all whitespace-nowrap cursor-pointer">
            En savoir plus
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
